export enum ProjectsLayoutMode {
  GRID = 'grid',
  LIST = 'list',
  MAP_VIEW = 'map_view'
}
